export default __webpack_public_path__ + "static/media/01.46bad109.jpg";